import type { BaseModalProps } from '@byecode/ui'
import { DesktopModal, Modal } from '@byecode/ui'
import React from 'react'

import DeepSeekAccount from './DeepSeekAccount'

interface DeepSeekAccountModalProps extends BaseModalProps {}

export const DeepSeekAccountModal: React.FunctionComponent<DeepSeekAccountModalProps> = ({ ...rest }) => {
    return (
        <DesktopModal
            width={676}
            {...rest}
            styles={{
                modal: {
                    maxHeight: 'calc(100% - 48px)'
                },
                body: {
                    padding: '0!important'
                },
                header: {
                    borderStyle: 'none'
                }
            }}
        >
            <DeepSeekAccount onClose={rest.onClose} />
        </DesktopModal>
    )
}
